// Ordem, visibilidade e largura das colunas da programação Havan: iguais nos dois turnos, salvas neste navegador.
// Uma coluna nova (que não estava no layout salvo) aparece na posição e na largura padrão dela.

export const CHAVE_LAYOUT_COLUNAS = 'programacao-havan-colunas-v1';

// O CT identifica a carga: não pode ser ocultado.
export const COLUNAS_SEMPRE_VISIVEIS = ['ct'];

// Limites ao arrastar a borda do cabeçalho (px): estreita o bastante para "Vol.", larga o bastante para a observação.
export const LARGURA_MINIMA = 60;
export const LARGURA_MAXIMA = 900;

export const LAYOUT_PADRAO = { ordem: [], ocultas: [], larguras: {} };

// Só larguras numéricas, arredondadas e dentro dos limites (um valor estranho no navegador não quebra a tabela).
export const normalizarLarguras = larguras => Object.entries(larguras && typeof larguras === 'object' ? larguras : {})
  .filter(([id, largura]) => typeof id === 'string' && Number.isFinite(Number(largura)))
  .reduce((acc, [id, largura]) => ({ ...acc, [id]: Math.min(LARGURA_MAXIMA, Math.max(LARGURA_MINIMA, Math.round(Number(largura)))) }), {});

export const carregarLayoutColunas = () => {
  try {
    const salvo = JSON.parse(window.localStorage.getItem(CHAVE_LAYOUT_COLUNAS) || 'null');
    if (!salvo || !Array.isArray(salvo.ordem) || !Array.isArray(salvo.ocultas)) return LAYOUT_PADRAO;
    return {
      ordem: salvo.ordem.filter(id => typeof id === 'string'),
      ocultas: salvo.ocultas.filter(id => typeof id === 'string'),
      // Layout salvo antes das larguras: sem larguras, cada coluna fica no tamanho padrão.
      larguras: normalizarLarguras(salvo.larguras)
    };
  } catch {
    return LAYOUT_PADRAO;
  }
};

export const layoutPersonalizado = layout => Boolean(layout?.ordem?.length || layout?.ocultas?.length || Object.keys(layout?.larguras || {}).length);

export const salvarLayoutColunas = layout => {
  try {
    if (!layoutPersonalizado(layout)) window.localStorage.removeItem(CHAVE_LAYOUT_COLUNAS);
    else window.localStorage.setItem(CHAVE_LAYOUT_COLUNAS, JSON.stringify({ ...layout, larguras: normalizarLarguras(layout.larguras) }));
  } catch {
    // Navegador sem armazenamento (aba anônima bloqueada): o layout vale só até recarregar.
  }
};

// Larguras que o usuário acabou de arrastar entram por cima das já salvas (os dois turnos somam ajustes).
export const comLarguras = (layout, larguras) => ({
  ...LAYOUT_PADRAO,
  ...layout,
  larguras: normalizarLarguras({ ...(layout?.larguras || {}), ...(larguras || {}) })
});

// Colunas que voltaram ao tamanho padrão (duplo clique na borda) saem das larguras salvas.
export const semLarguras = (layout, ids) => ({
  ...layout,
  larguras: Object.fromEntries(Object.entries(layout?.larguras || {}).filter(([id]) => !(ids || []).includes(id)))
});

// Ordem final dos ids: os do layout salvo que ainda existem e, depois, cada coluna nova logo após a vizinha da ordem padrão.
export const ordenarIds = (idsPadrao, ordemSalva) => {
  const existentes = (ordemSalva || []).filter(id => idsPadrao.includes(id));
  if (!existentes.length) return [...idsPadrao];
  const resultado = [...existentes];
  idsPadrao.forEach((id, indice) => {
    if (resultado.includes(id)) return;
    const anterior = idsPadrao.slice(0, indice).reverse().find(vizinho => resultado.includes(vizinho));
    resultado.splice(anterior ? resultado.indexOf(anterior) + 1 : 0, 0, id);
  });
  return resultado;
};

// A largura salva vira o tamanho da coluna: vale nos dois turnos e no próximo acesso.
export const aplicarLayoutColunas = (colunas, layout) => {
  const larguras = layout?.larguras || {};
  const porId = Object.fromEntries(colunas.map(coluna => [coluna.id, {
    ...coluna,
    minSize: LARGURA_MINIMA,
    maxSize: LARGURA_MAXIMA,
    ...(larguras[coluna.id] ? { size: larguras[coluna.id] } : {})
  }]));
  const ocultas = new Set((layout?.ocultas || []).filter(id => !COLUNAS_SEMPRE_VISIVEIS.includes(id)));
  return ordenarIds(colunas.map(coluna => coluna.id), layout?.ordem)
    .filter(id => !ocultas.has(id))
    .map(id => porId[id]);
};
